import { WprBaseComponent } from './WprBaseComponent';
import { IWprModeProps } from '../props/IWprModeProps';
import { IWprModeState } from '../props/IWprModeState';
import { WprComponentModeInfo } from '../mode/WprComponentModeInfo';

/**
 * コントロール基本コンポーネント
 */
export abstract class WprBaseModeComponent<T extends IWprModeProps> extends WprBaseComponent<T, IWprModeState> {
	// private 変数  ------------------------------------------------------------
	private m_Visible: boolean						= false;			// 表示状態
	private m_ModeInfoList: WprComponentModeInfo[]	= new Array();		// コンポーネントモード情報リスト
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: T) {
		super(props);
		this.initMode();
		this.props.view.addModeComponet(this);
		this.state = {
			visible: this.m_Visible
		};
	}
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** コンポーネントモード情報リスト */
	public get modeInfoList(): WprComponentModeInfo[] 	{ return this.m_ModeInfoList; 	}
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * 表示状態設定処理
	 * @param visible 表示状態
	 */
	public setVisible(visible: boolean): void {
		if (this.isMount === false)
			return;
		if (this.m_Visible !== visible) {
			this.m_Visible = visible;
			this.setState({
				visible: this.m_Visible
			});
		}
	}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * モード情報初期化処理
	 */
	private initMode() {
		const mode = this.props.mode.trim();
		if (mode.includes(',') === true) {
			mode.split(',').forEach(mbuf => {
				this.addModeInfoList(mbuf.trim());
			});
		}
		else {
			this.addModeInfoList(mode);
		}
	}

	/**
	 * モード情報リスト追加
	 * @param mode モード
	 */
	private addModeInfoList(mode: string): void {
		if (mode.includes('.') === true) {
			const list = mode.split('.');
			this.m_ModeInfoList.push(new WprComponentModeInfo(list[0].trim(), list[1].trim()));
		}
		else {
			this.m_ModeInfoList.push(new WprComponentModeInfo(undefined, mode));
		}
	}
	// --------------------------------------------------------------------------
}
